export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_01.f5ecbb14.jpg";